<template>
  <div class="crm-main-cont">
    <div class="search-box">
      <a-form :form="formSearch" layout="inline">
        <a-form-item label="单位名称" v-bind="layoutStyle2">
          <a-input v-decorator="['dwName']"/>
        </a-form-item>

        <a-form-item label="状态" v-bind="layoutStyle2">
          <a-select v-decorator="['dwStatus']" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
    <div class="btns-group">
      <a-button type="primary" @click="handleSearch">
        搜索
      </a-button>
      <a-button @click="handleReset">
        重置
      </a-button>
      <a-button type="primary" @click="addProduct">
        金融机构添加
      </a-button>
    </div>

    <a-table bordered rowKey="id" :pagination="pagination" :dataSource="dataSource" @change="change" :columns="columns"
             :scroll="{ x: 1500 }">
      <template slot="dwStatus" slot-scope="text">
        <span v-if="text === 1">启用</span>
        <span v-if="text === 0">禁用</span>
      </template>
      <template slot="operation" slot-scope="text, record">
        <a v-if="record.dwStatus === 0" @click="() => start(record)">
          启用
        </a>
        <a v-if="record.dwStatus === 1" @click="() => stop(record)">
          停用
        </a>
        <a v-if="record.dwStatus === 1" @click="() => edit(record)">
          修改
        </a>
        <a v-if="record.dwStatus === 1" @click="() => showModal(record)">
          修改记录
        </a>
        <a v-if="record.dwStatus === 1" @click="() => view(record)">
          详情
        </a>
      </template>
    </a-table>

    <a-drawer
        :title="titleName+'金融机构'"
        :width="650"
        @close="onClose"
        :visible="visible"
    >
      <a-form :form="form" layout="vertical">
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="机构全称">
              <a-input
                  v-decorator="['full_name', {
                                    rules: [{ required: true, message: '请填写机构全称' },{
										min:2,max:20,message: '请填入字符在2-20个字符之间的内容'
									}]
                                    }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="机构简称">
              <a-input
                  v-decorator="['short_name', {
                                  rules: [{
                                  required: true, message: '请填写机构简称' },{
										min:2,max:20,message:'请填入字符在2-20个字符之间的内容'
                                   }],
                                  }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="机构类型">
              <a-select
                  v-decorator="['organization_type', {
                            rules: [{ required: true, message: '请选择机构类型' }]
                }]" placeholder="请选择机构类型"
              >

                <a-select-option value="银行">
                  银行
                </a-select-option>
                <a-select-option value="担保公司">
                  担保公司
                </a-select-option>
                <a-select-option value="保险公司">
                  保险公司
                </a-select-option>
                <a-select-option value="小额贷款公司">
                  小额贷款公司
                </a-select-option>
                <a-select-option value="融资租赁公司">
                  融资租赁公司
                </a-select-option>
                <a-select-option value="保理公司">
                  保理公司
                </a-select-option>
                <a-select-option value="风险投资机构">
                  风险投资机构
                </a-select-option>
                <a-select-option value="消费金融公司">
                  消费金融公司
                </a-select-option>
                <a-select-option value="资产管理公司">
                  资产管理公司
                </a-select-option>
                <a-select-option value="信托公司">
                  信托公司
                </a-select-option>
                <a-select-option value="基金公司">
                  基金公司
                </a-select-option>
                <a-select-option value="其他">
                  其他
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
                label="区域"
            >
              <a-select v-decorator="['region', {
                  rules: [{ required: true, message: '请选择所在区域' }]
                }]"
                        placeholder="请选择所在区域"
              >
                <a-select-option v-for="item in regionMark" :key="item.desc">
                  {{ item.desc }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="详细地址">
              <a-input
                  v-decorator="['address',{
											rules: [{
											 },{
												min:2,
												max:50,
												message:'请填入字符在字符在2-50个字符之间的内容'
											 }]
										} ]"

              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="排序">
              <a-input-number
                  v-decorator="['sort',{
                  rules: [{ required: true, message: '请填写排序序号' }]
                }]"

              />
            </a-form-item>
          </a-col><a-col :span="12">
          <a-form-item label="机构编码(不填默认为“ZZZZZZ111111111”)">
            <a-select
                class="selCls"
                show-search
                allowClear
                placeholder="请输入机构编码或机构名称检索"
                option-filter-prop="children"
                :filter-option="false"
                @change="handleChange"
                @search="initOrgInfoList"
                :dropdownMenuStyle="{fontSize:'10px'}"
                v-decorator="['orgCode',{
											rules: [{
											 },{
												message:'请选择机构编码'
											 }]
										} ]"
            >
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option  v-for="(item,index) in orgInfoList" :key="item.organizationCode" :value="item.mechanismName+'/'+item.organizationCode">
                <p>{{item.organizationCode}}</p>
                <p style="font-size: 10px">{{item.mechanismName}}</p>
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
          <a-col :span="12">
            <a-form-item label="机构统一社会信用代码">
              <a-input
                  :maxLength="18"
                  v-decorator="['uniscId', {
                                  rules: [{
                                  required: true, message: '请填写机构统一社会信用代码' },],
                                  }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="简介">
              <a-textarea
                  v-decorator="['introduction', {rules: [{
											 },{
												min:2,
												max:800,
												message:'请填入字符在字符在2-800个字符之间的内容'
											 }]

                }]"
                  :rows="3"
                  placeholder="请填写机构简介(800字以内)"

              />
            </a-form-item>
          </a-col>

        </a-row>
        <a-row :gutter="16">
          <a-col :span="12">
            <a-form-item label="LOGO">
              <a-upload name="logo" :customRequest="customRequest1" :showUploadList="false" listType="picture-card"
                        class="avatar-uploader"
                        :beforeUpload="beforeUpload1" @change="handleChange1"
                        v-decorator="['logo', {
                                  rules: [{
                                        required: true, message: '请上传图片' }],
                                }]">
                <img v-if="imageUrl" :src="downPath+imageUrl" alt="avatar" width="100"/>
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'"/>
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>
      <div
          :style="{
          position: 'absolute',
          left: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
        }"
      >
        <a-button @click="submitPro" type="primary" v-if="!ifedit">提交</a-button>
        <a-button @click="updateYx" type="primary" v-if="ifedit">修改</a-button>
      </div>
    </a-drawer>
    <a-drawer
        title="金融机构详情"
        :width="650"
        @close="viewClose"
        :visible="viewable"
    >
      <a-descriptions
          bordered
          :column="2"
      >
        <a-descriptions-item label="机构全称" :span="2">
          {{ showItem.full_name }}
        </a-descriptions-item>
        <a-descriptions-item label="机构简称">
          {{ showItem.short_name }}
        </a-descriptions-item>
        <a-descriptions-item label="机构类型">
          {{ showItem.organization_type }}
        </a-descriptions-item>
        <a-descriptions-item label="所在区域">
          {{ showItem.region }}
        </a-descriptions-item>
        <a-descriptions-item label="排序">
          {{ showItem.sort }}
        </a-descriptions-item>
        <a-descriptions-item label="地址" :span="2">
          {{showItem.address}}
        </a-descriptions-item>
        <a-descriptions-item label="简介" :span="2">
          <p v-html="showItem.introduction" style="white-space: pre-line"></p>
        </a-descriptions-item>
      </a-descriptions>
    </a-drawer>

    <a-spin tip="Loading..." :spinning="spinning">
      <a-modal
          v-model="visible2"
          title="历史信息"
          onOk="handleOk"
          width="800px"
      >
        <template slot="footer">
          <a-button key="submit" type="primary" @click="handleOk">
            确定
          </a-button>
        </template>
        <a-table rowKey="id" bordered :dataSource="listRecord" :pagination="pagination2" @change="change2"
                 :columns="columnsRecord"></a-table>
      </a-modal>
    </a-spin>
  </div>
</template>

<script>
const columns = [
  {title: '机构全称', dataIndex: 'full_name', ellipsis:true,width: 250, fixed: 'left'},
  {title: '机构简称', dataIndex: 'short_name', ellipsis:true,width: 150},
  {title: '机构类型', dataIndex: 'organization_type', ellipsis:true,width: 150},
  {title: '所在区域', dataIndex: 'region', ellipsis:true,width: 100},
  {title: '地址', dataIndex: 'address',ellipsis:true,},
  /*    {
          title: '简介',
          dataIndex: 'introduction',
          scopedSlots: {customRender: 'introduction'},
          width:"10%",

      },*/
  {
    title: '状态',
    dataIndex: 'dwStatus',
    scopedSlots: {customRender: 'dwStatus'},
    width: 100

  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: {customRender: 'operation'},
    fixed: 'right',
    width: 170

  },


];

const columnsRecord = [
  {title: '字段名',dataIndex: 'yxdwColum'},
  {title: '该次修改前信息',dataIndex: 'beforeInfo'},
  {title: '该次修改后信息',dataIndex: 'afterInfo'},
  {title: '该次修改时间', dataIndex: 'updateAt'}
];

import {
  getYxdwList,
  addYxdw,
  uoloadFile,
  updateYxdw,
  disable,
  enable,
  getHisInfos,
  getTypes,
  getOrgInfoList
} from "@/api/operate/employer";
import axios from "axios";
import qs from "qs";
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState(["downPath"]),
  },
  data() {
    return {
      regionMark: [],
      layoutStyle2: "",
      titleName: "添加",
      loading: false,
      spinning: false,
      ifedit:false,
      columns,
      columnsRecord,
      dateFormat: 'YYYY/MM/DD',
      listRecord: [],
      checkFlag: "",
      one: [],
      search: {
        dwName: "",
        uscc: "",
        dwStatus: "",
        current: ""
      },
      showId: "",
      editItem: "",
      viewable:false,
      showItem:{},
      uploadImgUrl: "",
      imageUrl: "",
      form: this.$form.createForm(this),
      formSearch: this.$form.createForm(this),
      visible: false,
      visible2: false,
      dataSource: [],
      types: [],
      times: "",
      times3: "",
      orgInfoList: [],
      orgCode: "",
      orgName: "",
      fetching: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    getYxdwList(1)
        .then(res => {
          next(vm => {
            vm.$ajaxAfter(res).then(() => {
              vm.pagination = {
                current: res.data.data.page.pageNum,
                total: res.data.data.page.total,
                pageSize: res.data.data.page.pageSize
              };
              vm.dataSource = res.data.data.page.list;
              vm.getDwType();
              vm.getQyType();//加载区域字典数据
            });
          });
        })
        .catch(() => {
          next(vm => {
            vm.$message.error("服务器出错！请稍后再试!");
            vm.$Progress.fail();
          });
        });
  },
  methods: {
    initList() {
      getYxdwList(this.search)
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.dataSource = res.data.data.page.list;
              Object.assign(this.pagination, {
                total: res.data.data.page.total,
                pageSize: res.data.data.page.pageSize,
                current: res.data.data.page.pageNum
              });
              Object.assign(this.search, {
                current: res.data.data.page.pageNum
              });
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    handleSearch() {
      let values = this.formSearch.getFieldsValue();
      Object.assign(this.search, {
        dwName: values.dwName || "",
        uscc: values.uscc || "",
        dwStatus: values.dwStatus,
        current: 1
      });
      this.initList();
    },
    handleReset() {
      this.formSearch.resetFields();
      Object.assign(this.search, {
        dwName: "",
        uscc: "",
        dwStatus: "",
        current: 1
      });
      this.initList();
    },
    getDwType() {
      getTypes("003001")
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.types = res.data.data.list;
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });

    },
    getQyType() {
      getTypes("003007")
          .then(res => {
            this.$ajaxAfter(res).then(() => {
              this.regionMark = res.data.data.list;
            });
          })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    handleChange(value){
      if (value){
        this.fetching = false;
        let data = value.split("/");
        this.orgName = data[0];
        this.orgCode = data[1];
        this.form.setFieldsValue({
          orgCode: data[1]
        })
      }else{
        this.orgCode = null;
        this.orgName = null;
      }
    },
    initOrgInfoList(input){
      this.fetching = true;
      if (/[\u4E00-\u9FA5\uFE30-\uFFA0]/.test(input)){
        this.orgCode = "";
        this.orgName = input;
      }else {
        this.orgCode = input;
        this.orgName = "";
      }
      getOrgInfoList(this.orgName,this.orgCode).then(res=>{
        if(res.data.success == "TRUE"){
          this.$nextTick(()=>{
            this.$set(this,"orgInfoList",res.data.data.list)
            this.fetching = false;
          })
        }
      }).catch(()=>{
        this.$message.error("初始化机构列表异常，请稍后再试！")
      })
    },
    onChange(date, dateString) {
      this.times = dateString;
    },
    onClose() {
      this.form.resetFields();
      this.visible = false;
      this.uploadImgUrl = "";
      this.imageUrl = "";
    },

    addProduct() {
      this.visible = true;
      this.titleName = "添加";
      this.ifedit=false;
    },
    edit(data2) {
      this.ifedit=true;
      this.titleName = "修改";
      this.visible = true;
      this.imageUrl = data2.logo,
          this.editItem = data2;
      setTimeout(() => {
        this.form.setFieldsValue({
          organization_type: data2.organization_type,
          full_name: data2.full_name,
          short_name: data2.short_name,
          region: data2.region,
          address: data2.address,
          introduction: data2.introduction,
          logo:data2.logo,
          sort:data2.sort,
          orgCode: data2.orgCode,
          uniscId: data2.uniscId,
        });
        this.orgCode = data2.orgCode;
        this.orgName = data2.mechanismName;
      }, 0);
    },
    change(page) {
      this.pagination.current = page.current;
      this.search.current = page.current;
      this.initList();
    },
    change2(page) {
      this.pagination2.current = page.current;
      this.showInfos();
    },
    submitPro() {
      this.form.validateFields((err, values) => {
        values.logo = this.uploadImgUrl;
        if (!err) {
          values.orgCode = this.orgCode;
          values.orgName = this.orgName;
          addYxdw(values)
              .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.$message.success("创建机构成功!");
                  this.visible = false;
                  this.initList();
                  this.form.resetFields();
                  this.uploadImgUrl = "";
                  this.imageUrl = "";
                });
              })
              .catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
              });
          this.form.resetFields();
          this.uploadImgUrl = "";
          this.imageUrl = ""
        }
      });

    },
    handleChange1(info) {

      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} 文件上传成功`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    beforeUpload1(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif')
      if (!isJPG) {
        this.$message.error('你只能上传图片!')
        return false;
      }
      const isLt300k = file.size / 1024;
      if (isLt300k > 300) {
        this.$message.error('图片只能小于300k!')
        return false;
      }
      return isJPG && isLt300k
    },
    customRequest1(files) {
      this.text = files.text;
      let formData = new FormData();
      formData.append("file", files.file);

      uoloadFile(formData).then(res => {
        if (res.data.success === "TRUE") {
          this.uploadImgUrl = res.data.data.value;
          this.$message.success("图片上传成功!")
          this.imageUrl = this.uploadImgUrl;
          this.loading = false;
        }
      }).catch(() => {
        this.$message.error("上传错误，请重新上传!")
      })
    },
    updateYx() {
      this.form.validateFields((err, values) => {
        if (!err) {
          values.id = this.editItem.id;
          values.logo = this.imageUrl;
          values.orgCode = this.orgCode;
          values.orgName = this.orgName;
          updateYxdw(values)
              .then(res => {
                this.$ajaxAfter(res).then(() => {
                  this.$message.success("修改机构成功！");
                  this.visible = false;
                  this.initList();
                });
              })
              .catch(() => {
                this.$message.error("服务器出错！请稍后再试!");
              });
        }
      });
    },
    stop(record) {
      disable(record).then(res => {
        this.$ajaxAfter(res).then(() => {
          if (res.data.success === "TRUE") {
            this.$message.success("机构停用已成功！");
            this.visible = false;
            this.initList();
          }
        });
      })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    start(record) {
      enable(record).then(res => {
        this.$ajaxAfter(res).then(() => {
          if (res.data.success === "TRUE") {
            this.$message.success("用户启用成功！");
            this.visible = false;
            this.initList();
          }
        });
      })
          .catch(() => {
            this.$message.error("服务器出错！请稍后再试!");
          });
    },
    //审核列表
    showModal(record) {

      this.showId = record.id;
      this.pagination2.current=1;
      this.showInfos();
      this.visible2 = true;
    },

    //审核列表
    showInfos() {
      this.spinning = true;
      getHisInfos(this.showId, this.pagination2.current)
          .then(res => {
            if (res.data.success === "TRUE") {
              res.data.data.page.list.map(item => {
                item.updateAt = this.formatDate(item.updateAt);
              });
              this.listRecord = res.data.data.page.list;
              this.pagination2 = {
                current: res.data.data.page.pageNum,
                pageSize: res.data.data.page.pageSize,
                total: res.data.data.page.total
              };
            }
          });
      this.spinning = false;
    },
    handleOk() {
      this.visible2 = false;
    },
    view(data){
      this.viewable = true;
      this.showItem = data;
    },
    viewClose(){
      this.viewable = false;
      this.showItem = {};
    },
    formatDate(dates)
    {
      dates = new Date(dates);
      let date = {
        year: dates.getFullYear(),
        month:
            dates.getMonth() + 1 < 10
                ? "0" + (dates.getMonth() + 1)
                : dates.getMonth() + 1,
        day: dates.getDate() < 10 ? "0" + dates.getDate() : dates.getDate(),
        hour: dates.getHours() < 10 ? "0" + dates.getHours() : dates.getHours(),
        minute:
            dates.getMinutes() < 10
                ? "0" + dates.getMinutes()
                : dates.getMinutes(),
        second:
            dates.getSeconds() < 10
                ? "0" + dates.getSeconds()
                : dates.getSeconds()
      };
      return (date.year + "-" + date.month + "-" + date.day + " " + date.hour + ":" + date.minute + ":" + date.second);
    }
  },
}
</script>


<style scoped lang="less">
.ant-btn {
  font-size: 12px;
}

.search-box {
  .ant-form-item {
    display: inline-block;
    min-width: 280px;
  }

  .ant-select {
    width: 169px;
  }
}

.btns-group button {
  margin-right: 10px;
  margin-top: 24px;
  margin-bottom: 10px;
}

.ant-table-wrapper {
  font-size: 12px;
  margin-top: 20px;
}

.ant-table-row > td {
  font-size: 12px;
}
/deep/ .ant-descriptions-item-label{
  width: 20%;
}
/deep/ .selCls .ant-select-selection.ant-select-selection--single{
  overflow: hidden;
}
</style>
